import { Checkbox, FormControlLabel } from '@mui/material';
import { FunctionComponent } from 'react';
import { gameConfigStore, useGameConfigSelector } from '../../store/GameConfigStore';
import { useAppDispatch } from '../../store/Hooks';

export const SensorySensitivityCheckbox: FunctionComponent = () => {
	const dispatch = useAppDispatch();
	const enabled = useGameConfigSelector(gameConfigStore.selectors.sensorySensitivityMode);

	function handleChange(enabled: boolean) {
		dispatch(gameConfigStore.actions.setSensorySensitivityMode(enabled));
	}

	return <FormControlLabel
		control={
			<Checkbox
				checked={enabled}
				onChange={(e) => handleChange(e.target.checked)}
			/>
		}
		label="Sensory sensitivity mode (reduced animation and sound)"
		sx={{ marginTop: 2, marginX: 1 }}
	/>;
};
